import type { Money } from "@/lib/domain/Money";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface VariantHistoricalPricingModel {
	readonly variantId: string;
	readonly prices: HistoricalPricing[];
}

export interface HistoricalPricing {
	readonly date: string;
	readonly price: Money;
}

export const useProductHistoricalPricing = (productId: string, days: string) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["productPricing", productId, days],
		queryFn: () => http<VariantHistoricalPricingModel[]>({
			method: "GET",
			url: `/product/${productId}/historical-pricing?days=${days}`
		}),
		placeholderData: x => x
	});
};
